<template>
	<el-container class="skin">
		<!-- 顶部导航栏组件 -->
		<Header
			:top-naves="topNaves"
			v-model:menu-active="menuActive"
			:msg-num="msgNum"
			:other-num="otherNum"
			:msg-loading="msgLoading"
			v-model:active-name-msg="activeNameMsg"
			:msg-list="msgList"
			:other-list="otherList"
			:show_scroll="show_scroll"
			:user-info-all="userInfoAll"
			@handle-click-menus="handleClickMenus"
			@show-scroll="showScorll"
			@message-readed="messageReaded"
			@message-readed-other="messageReadedOther"
			@load="load"
			@load-other="loadOther"
			@read-all="readAllFun"
			@go-user-info="goUserInfo"
			@go-operating-manual="goOperatingManual"
			@clear-cache="clearCache"
			@logout="onLogout"
			@go-data-center="goDataCenter"
		/>

		<el-container>
			<!-- 侧边栏 -->
			<el-aside
				:class="[show_aside ? 'el-asideN' : 'el-asideW']"
				v-if="currentRootItem && !currentRootItem.hideSide && routes && routes.length"
			>
				<el-scrollbar>
					<side-bar :routes="routes" v-model:activeIndex="activeIndex"></side-bar>
				</el-scrollbar>
			</el-aside>

			<!-- 主内容区域 -->
			<el-main class="fex-column">
				<!-- 面包屑导航组件 -->
				<Breadcrumb
					v-if="!isHomePage"
					:current-root-item="currentRootItem"
					:routes="routes"
					:show_aside="show_aside"
					:bread-list="breadList"
					@show-aside="showAside"
					@breadcrumb-click="breadcrumbClick"
					@breadcrumb-contextmenu="breadcrumbContextmenu"
					@close-out-selected-tag="closeOutSelectedTag"
				/>

				<div class="main-content">
					<router-view v-slot="{ Component, route }">
						<keep-alive :max="15" :include="cacheList">
							<component :is="Component" :key="route.fullPath" />
						</keep-alive>
					</router-view>
				</div>
			</el-main>
		</el-container>
	</el-container>

	<!-- 消息详情弹窗组件 -->
	<MessageDialog
		v-model:msg-show="msgShow"
		:active-msg="activeMsg"
		@cancel-operate="cancelOperate"
		@view-detail="viewDetail"
	/>

	<!-- 用户信息抽屉组件 -->
	<UserDrawer
		v-model:is-show-user="isShowUser"
		:loading="loading"
		:user-info-all="userInfoAll"
		@close-user="closeUser"
		@handle-click="handleClick"
		@refresh-user-info="onGetUserInfo"
	/>

	<!-- 右键菜单组件 -->
	<ContextMenu
		:visible="visible"
		:left="left"
		:top="top"
		:is-refresh="isRefresh"
		:is-close-selected="isCloseSelected"
		:is-close-others="isCloseOthers"
		:is-close-left="isCloseLeft"
		:is-close-right="isCloseRight"
		@refresh-selected-tag="refreshSelectedTag"
		@close-selected-tag="closeSelectedTag"
		@close-others-tags="closeOthersTags"
		@close-left-tags="closeLeftTags"
		@close-right-tags="closeRightTags"
	/>
	<!-- 部门验证信息 -->
	<departmentInfo
		v-if="departmentOpen"
		:info="departmentInfos"
		@confirm="departmentConfirm"
		@close="departmentClose"
	></departmentInfo>
	<productInfo
	v-if="productOpen" @close="produtClose"></productInfo>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SideBar from '@/layout/sidebar'
import Header from './components/Header.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import MessageDialog from './components/MessageDialog.vue'
import UserDrawer from './components/UserDrawer.vue'
import ContextMenu from './components/ContextMenu.vue'
import departmentInfo from './components/departmentInfo.vue'
import productInfo from './components/productInfo.vue'
import menus from '@/config/menus.js'
import { getUserInfo, getMessage } from '@/api/common.js'
import config from '@/config/config'
import { useWebSocket } from '@vueuse/core'
import {
	queryMsgList,
	queryMsgRead,
	queryMsgReadOther,
	queryMsgReadOtherNum,
	branchYueAll,
	read_all,
	logout
} from '@/api/operate/socket'
import { addOperate, OnOffOperate } from '@/api/operate/home'
import { ElNotification, ElMessage, ElLoading } from 'element-plus'
import { apiMenuList, get_operating_manual_url, onClearCache } from '@/api/login'

const router = useRouter()
const route = useRoute()
const productOpen = ref(false)
// 响应式数据
const show_aside = ref(false)
const msgLoading = ref(false)
const activeNameMsg = ref('公告')
const show_scroll = ref(false)
const show_scroll2 = ref(false)
const topNaves = ref([])
const routes = ref([])
const currentRootItem = ref(null)
const activeIndex = ref('0')
const breadList = ref([])
const userInfo = ref(localStorage.getItem(config.USERINFO))
const msgNum = ref(0)
const otherNum = ref(0)
const warnInfo = ref('')
const msgList = ref([])
const otherList = ref([])
const activeMsg = ref({})
const msgShow = ref(false)
const page = ref(1)
const pageOther = ref(1)
const detailItem = ref({})
const apiMenus = ref([])
const confimOperate = ref(false)
const activeSchool = ref([])
const campusArr = ref([])
const campusProps = ref({
	value: 'id',
	label: 'name',
	children: 'child',
	checkStrictly: true,
	multiple: true
})
const userInfoAll = ref({})
const isShowUser = ref(false)
const loading = ref(false)
const menuActive = ref('')
const visible = ref(false)
const left = ref(0)
const top = ref(0)
const activeMenu = ref([])
const isRefresh = ref(true)
const isCloseSelected = ref(true)
const isCloseOthers = ref(true)
const isCloseLeft = ref(true)
const isCloseRight = ref(true)
const cacheList = ref([])
const current_path = ref('')
const departmentOpen = ref(false) // 部门验证信息弹窗
const departmentInfos = ref({}) // 部门验证信息

// 计算属性
const isHomePage = computed(() => {
	// 首页与应用导航不显示面包屑，保持一致
	return route.path === '/' || route.path === '/navigation'
})

// 监听路由变化
watch(
	() => route.path,
	(newPath) => {
		current_path.value = newPath
		selected()
		getBreadcrumb()
		if (!cacheList.value.includes(route.name)) {
			cacheList.value.push(route.name)
		}
	}
)

// 方法

const departmentConfirm = () => {
	departmentOpen.value = false
}
const departmentClose = () => {
	departmentOpen.value = false
}
const produtClose = () => {
	productOpen.value = false
}
const allClick = () => {
	visible.value = false
}

const showAside = () => {
	show_aside.value = !show_aside.value
}

const showScorll = () => {
	show_scroll.value = true
}

const closeUser = () => {
	// activeName 在 Vue 3 中可能需要重新定义
}

const handleClick = (e) => {
	// activeName 在 Vue 3 中可能需要重新定义
	onGetUserInfo()
}

const handleClickMenus = (tab, event) => {
	onMenuClick(JSON.parse(tab.props.name))
}

const goDataCenter = () => {
	router.push({ path: '/dataCenter' })
}

const goUserInfo = () => {
	isShowUser.value = true
}

const onGetUserInfo = async () => {
	loading.value = true
	try {
		const res = await getUserInfo()
		if (res.code == 200) {
			userInfoAll.value = res.data
				
			if(localStorage.getItem('announcementNotice') == 0){
				productOpen.value = false //打开公告通知
			}
			if (userInfoAll.value.avatar_url != null) {
				userInfoAll.value.pic_l = [{ url: userInfoAll.value.avatar_url }]
			} else {
				userInfoAll.value.pic_l = []
			}
			if (userInfoAll.value.promote_url != null) {
				userInfoAll.value.pic_t = [{ url: userInfoAll.value.promote_url }]
			} else {
				userInfoAll.value.pic_t = []
			}

			if (userInfoAll.value.wechat_url != 0 && userInfoAll.value.wechat_url != null) {
				userInfoAll.value.pic_w = [{ url: userInfoAll.value.wechat_url }]
			} else {
				userInfoAll.value.pic_w = []
			}
			if (userInfoAll.value.is_sure == 0) {
				departmentOpen.value = true
				departmentInfos.value.dept = userInfoAll.value.dept
				departmentInfos.value.depts = userInfoAll.value.depts
			} else {
				departmentOpen.value = false
			}
		} else {
			ElMessage({
				type: 'warning',
				message: '获取用户信息失败'
			})
		}
	} catch (error) {
		console.error('获取用户信息失败:', error)
	} finally {
		loading.value = false
	}
}

// 选中状态
const selected = () => {
	menus.forEach((item) => {
		item.is_active = item.urls.includes(current_path.value)
		menuRecursion(item, null, item)
		judgmentActiveItem(item)
		if (item.is_active) {
			routes.value = item.children
			currentRootItem.value = item
			menuActive.value = JSON.stringify(item)
		}
	})
}

// 判断当前选中的底层路由
const judgmentActiveItem = (val) => {
	if (val.children && val.children.length) {
		judgmentActiveItem(val.children)
	} else {
		if (val.path == current_path.value) {
			activeIndex.value = val.activeIndex.toString()
		}
	}
}

const hierarchyJudgment = () => {
	return new Promise((resolve, reject) => {
		// 判断子集
		menus.forEach((el) => {
			if (el.children && el.children.length) {
				// 第一层
				el.children.forEach((val) => {
					// 第二层
					if (val.children && val.children.length) {
						val.children.forEach((item) => {
							if (routeExistsRecursively(apiMenus.value, item)) {
								item.hideSide = false
							} else {
								item.hideSide = true
							}
						})
						// 判断父级状态
						if (
							val.children.some((item) => {
								return item.hideSide === false
							})
						) {
							val.hideSide = false
						} else {
							val.hideSide = true
						}
					} else {
						if (routeExistsRecursively(apiMenus.value, val)) {
							val.hideSide = false
						} else {
							val.hideSide = true
						}
					}
				})
				// 判断父级状态
				if (
					el.children.some((val) => {
						return val.hideSide === false
					})
				) {
					el.hideSide = false
				} else {
					el.hideSide = true
				}
			} else {
				if (routeExistsRecursively(apiMenus.value, el)) {
					el.hideSide = false
				} else {
					el.hideSide = true
				}
			}
		})
		resolve()
	})
}

// 判断路由是否有权限
const routeExistsRecursively = (routes, path) => {
	for (const el of routes) {
		// 如果当前路由有子路由，则递归检查
		if (el.children && el.children.length) {
			// 递归调用 checkNestedRoutes，并检查返回值
			if (routeExistsRecursively(el.children, path)) {
				return true // 找到匹配项，立即返回 true
			}
		} else {
			// 否则，直接比较 name 和 title
			if (el.name === path.meta.title && path.path.includes('/' + el.url)) {
				return true // 找到匹配项，立即返回 true
			}
		}
	}
	return false
}

const queryMenus = () => {
	return new Promise((resolve, reject) => {
		apiMenuList()
			.then((res) => {
				apiMenus.value = res.data
				localStorage.setItem('menus', JSON.stringify(res.data))
				resolve()
			})
			.catch((error) => {
				reject(error)
			})
	})
}

const menuRecursion = (item, father, root) => {
	// 首页(/)、应用导航(/navigation) 等顶级路由直接允许显示
	if (item.path === '/' || item.path === '/navigation') {
		item.allow = true
		if (father) {
			father.allow = true
		}
		if (!root.redirect) {
			root.redirect = item.path
			root.activeIndex = item.id.toString()
		}
		if (item.path == current_path.value) {
			activeIndex.value = item.id.toString()
		}
	} else if (item.path && item.path != '/') {
		//检查权限 如果有权限则标识
		item.allow = true
		if (father) {
			father.allow = true
		}
		if (!root.redirect) {
			root.redirect = item.path
			root.activeIndex = item.id.toString()
		}
		if (item.path == current_path.value) {
			activeIndex.value = item.id.toString()
		}
	} else {
		if (item.children && item.children.length > 0) {
			item.children.forEach((child) => {
				menuRecursion(child, item, root)
			})
		}
	}

	if (item.allow) {
		if (father) {
			father.allow = true
		}
	}
}

// 点击菜单
const onMenuClick = (item) => {
	menus.forEach((item2) => {
		item2.is_active = false
	})

	item.is_active = true
	activeIndex.value = item.activeIndex
	if (item.meta.title == '首页') {
		router.push({ path: '/' })
	} else if (item.meta.title == '应用导航') {
		router.push({ path: '/navigation' })
	} else {
		apiMenus.value.forEach((el) => {
			if (el.name == item.meta.title) {
				if (el.children && el.children.length) {
					if (el.children[0].children && el.children[0].children.length) {
						router.push({ path: '/' + el.children[0].children[0].url })
					} else {
						router.push({ path: '/' + el.children[0].url })
					}
				} else {
					router.push({ path: item.redirect })
				}
			}
		})
	}
	routes.value = item.children
	currentRootItem.value = item
}

// 获取breadcrumb
const getBreadcrumb = () => {
	const currentPath = route.path
	const existingIndex = breadList.value.findIndex((item) => item.path === currentPath)

	// 如果是首页/应用导航，不添加到面包屑
	if (currentPath === '/' || currentPath === '/navigation') {
		return
	}
	if (existingIndex === -1) {
		// 如果路由不存在，添加到面包屑列表
		breadList.value.push({ ...route })
	} else {
		// 如果路由已存在，更新其状态
		breadList.value[existingIndex] = { ...route }
	}
	isActive()
}

// 登出
const onLogout = async () => {
	try {
		const res = await logout()
		if (res.code != 200) {
			ElMessage({
				type: 'warning',
				message: '登出失败,请联系相关人员处理~'
			})
		}
		localStorage.removeItem(config.TOKEN)
		localStorage.removeItem(config.USERINFO)
		localStorage.removeItem('menus')
		localStorage.removeItem('DC-dept')
		localStorage.removeItem('DC-study')
		localStorage.removeItem('salt')
		// 清除登录标记
		sessionStorage.removeItem('justLoggedIn')
		router.push({ path: '/login' })
	} catch (error) {
		console.error('登出失败:', error)
	}
}

// 清除缓存
const clearCache = async () => {
	let ClearLoading = ElLoading.service({
		text: '正在清除缓存，请稍候',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	try {
		const res = await onClearCache()
		if (res.code == 200) {
			ElMessage({
				type: 'success',
				message: '清除成功~'
			})
		} else {
			ElMessage({
				type: 'warning',
				message: '请稍后重试~'
			})
		}
	} catch (error) {
		console.error('清除缓存失败:', error)
	} finally {
		ClearLoading.close()
	}
}

// 跳转到使用手册
const goOperatingManual = async () => {
	try {
		const res = await get_operating_manual_url()
		let url = res.data
		window.open(url)
	} catch (error) {
		console.error('获取使用手册失败:', error)
	}
}

// 查看公告
const viewDetail = (e) => {
	router.push({
		path: '/operate/home',
		query: {
			title: activeMsg.value.title
		}
	})
	current_path.value = '/operate/home'

	ElMessage({
		type: 'success',
		message: '已跳转'
	})

	topNaves.value.forEach((item, index) => {
		if (item.meta.title == '产品运营中心') {
			item.is_active = true
			routes.value = item.children
			currentRootItem.value = item
			selected()
		}
	})

	getBreadcrumb() // 确保面包屑状态正确更新
	msgShow.value = false
}

// 取消运营
const cancelOperate = () => {
	// isShowDetail 在 Vue 3 中可能需要重新定义
	msgShow.value = false
}

const breadcrumbClick = (item, index) => {
	if (item && item.path) {
		router.push({ path: item.path, query: item.query })
		current_path.value = item.path
		selected()
		getBreadcrumb() // 确保面包屑状态正确更新
	}
}

const breadcrumbContextmenu = (item, index, e) => {
	if (breadList.value.length == 1) {
		return
	}
	activeMenu.value = item
	top.value = e.clientY
	left.value = e.clientX

	// 处理关闭当前/关闭其他
	if (breadList.value.length == 1) {
		isCloseSelected.value = false
		isCloseOthers.value = false
	} else {
		isCloseSelected.value = true
		isCloseOthers.value = true
	}
	// 处理关闭左侧
	if (index == 0) {
		isCloseLeft.value = false
	} else {
		isCloseLeft.value = true
	}
	// 处理关闭右侧
	if (index == breadList.value.length - 1) {
		isCloseRight.value = false
	} else {
		isCloseRight.value = true
	}

	visible.value = true
}

const isActive = () => {
	breadList.value.forEach((item, index) => {
		item.is_active = false
		if (item.path == route.path) {
			item.is_active = true
		}
	})
}

const refreshSelectedTag = () => {
	router.push({
		path: activeMenu.value.path,
		query: {
			...activeMenu.value.query,
			t: new Date()
		}
	})
	visible.value = false
}

// 删除缓存
const deleteCache = (val) => {
	cacheList.value.forEach((el, index) => {
		val.forEach((item) => {
			if (el == item.name) {
				cacheList.value.splice(index, 1)
			}
		})
	})
}

const closeOutSelectedTag = (item) => {
	activeMenu.value = item
	closeSelectedTag()
}

const closeSelectedTag = () => {
	breadList.value.forEach((el, index) => {
		if (el.path == activeMenu.value.path) {
			breadList.value.splice(index, 1)
		}
	})
	visible.value = false

	if (activeMenu.value.is_active) {
		breadList.value[breadList.value.length - 1].is_active = true
		router.push({
			path: breadList.value[breadList.value.length - 1].path,
			query: {
				...breadList.value[breadList.value.length - 1].query
			}
		})
	}
	deleteCache([activeMenu.value])
}

const closeOthersTags = () => {
	let arr = []
	let cache = []
	breadList.value.forEach((el, index) => {
		if (el.path == activeMenu.value.path) {
			arr = breadList.value.splice(index, 1)
			cache = breadList.value
		}
	})
	breadList.value = arr
	visible.value = false
	breadList.value[0].is_active = true
	router.push({
		path: breadList.value[0].path,
		query: {
			...breadList.value[0].query
		}
	})
	deleteCache(cache)
}

const closeLeftTags = () => {
	let cache = []
	breadList.value.forEach((el, index) => {
		if (el.path == activeMenu.value.path) {
			cache = breadList.value.splice(0, index)
		}
	})
	visible.value = false
	deleteCache(cache)
}

const closeRightTags = () => {
	let arr = []
	let cache = []
	breadList.value.forEach((el, index) => {
		if (el.path == activeMenu.value.path) {
			arr = breadList.value.splice(0, index + 1)
			cache = breadList.value
		}
	})
	breadList.value = arr
	visible.value = false
	if (!activeMenu.value.is_active) {
		router.push({
			path: breadList.value[breadList.value.length - 1].path,
			query: {
				...breadList.value[breadList.value.length - 1].query
			}
		})
	}
	deleteCache(cache)
}

// 连接websocket
const contentSOCK = () => {
	const { status, data, send, open, close } = useWebSocket('wss://wss.dcjy.top:8282', {
		// 连接成功的回调
		onConnected: function (ws) {},
		// 断开的情况
		onDisconnected: function (ws, event) {
			console.log('我断开了', event)
		},
		onError: function (ws, event) {},
		onMessage: function (ws, event) {
			if (!event.data.includes('logout')) {
				if (event && JSON.parse(event.data)) {
					switch (JSON.parse(event.data).type) {
						case 'init':
							send(
								JSON.stringify({
									type: 'init',
									a_id: JSON.parse(localStorage.getItem(config.USERINFO)).uid
								})
							)
							break
						case 'send':
							const info = JSON.parse(event.data).data
							warnInfo.value = info
							ElNotification({
								title: '您有一条新消息',
								message: info.title,
								type: 'warning',
								duration: 10000
							})
							if (JSON.parse(event.data).data.msg_type == 'notice') {
								msgList.value.unshift(JSON.parse(event.data).data)
								msgNum.value++
							} else {
								otherList.value.unshift(JSON.parse(event.data).data)
								otherNum.value++
							}
							break
					}
				}
			}
		},
		heartbeat: false,
		autoReconnect: {
			retries: 100,
			delay: 5000,
			onFailed() {
				// alert('多次重新连接失败，请检查网络后重新刷新')
			}
		},
		autoClose: true
	})
}

const getqueryMsgReadOtherNum = async () => {
	try {
		const res = await queryMsgReadOtherNum()
		otherNum.value = res.data.messageNum
		msgNum.value = res.data.noticeNum
	} catch (error) {
		console.error('获取消息数量失败:', error)
	}
}

//获取其他信息列表
const queryOtherList = async () => {
	msgLoading.value = true
	try {
		const res = await getMessage({
			page: pageOther.value
		})
		if (res.data.data.length > 0) {
			otherList.value = [...otherList.value, ...res.data.data]
		} else {
			if (otherList.value.length != 0) {
				ElMessage({
					type: 'warning',
					message: '没有更多了~'
				})
			}
		}
	} catch (error) {
		console.error('获取其他信息列表失败:', error)
	} finally {
		msgLoading.value = false
	}
}

// 获取公告消息列表数据
const queryMessageList = () => {
	msgLoading.value = true
	queryMsgList({
		emp_id: JSON.parse(localStorage.getItem(config.USERINFO)).uid,
		page: page.value
	})
		.then((res) => {
			if (res.data.data.length > 0) {
				msgList.value = [...msgList.value, ...res.data.data]
			} else {
				if (msgList.value.length != 0) {
					ElMessage({
						type: 'warning',
						message: '没有更多了~'
					})
				}
			}
			msgLoading.value = false
		})
		.catch((error) => {
			console.error('获取公告消息列表失败:', error)
			msgLoading.value = false
		})
}

// 消息 已读状态
const messageReaded = (val, index) => {
	if (msgList.value[index].is_yue == 1) {
		msgShow.value = true
		activeMsg.value = val
		return
	}
	queryMsgRead({
		ids: val.id
	})
		.then((res) => {
			msgShow.value = true
			activeMsg.value = val
			msgList.value[index].is_yue = 1
			msgNum.value--
		})
		.catch((error) => {
			console.error('标记消息已读失败:', error)
		})
}

//其他消息 已读消息
const messageReadedOther = (val, index) => {
	if (otherList.value[index].is_read == 1) {
		if (val.jump_link != '') {
			router.push(val.jump_link)
			current_path.value = val.jump_link
			ElMessage({
				type: 'success',
				message: '已跳转'
			})
			topNaves.value.forEach((item, index) => {
				if (item.urls.indexOf(val.jump_link) != -1) {
					item.is_active = true
					selected()
				}
			})
			getBreadcrumb() // 确保面包屑状态正确更新
		} else {
			ElMessage({
				type: 'warning',
				message: '该信息无跳转'
			})
		}
		return
	}
	queryMsgReadOther({
		id: val.id
	})
		.then((res) => {
			otherList.value[index].is_read = 1
			otherNum.value--
			if (val.jump_link != '') {
				if (val.jump_link != '') {
					router.push(val.jump_link)
					current_path.value = val.jump_link
					ElMessage({
						type: 'success',
						message: '已跳转'
					})
					topNaves.value.forEach((item, index) => {
						if (item.urls.indexOf(val.jump_link) != -1) {
							item.is_active = true
							selected()
						}
					})
					getBreadcrumb() // 确保面包屑状态正确更新
				} else {
					ElMessage({
						type: 'warning',
						message: '该信息无跳转'
					})
				}
			} else {
				ElMessage({
					type: 'warning',
					message: '该信息无跳转'
				})
			}
		})
		.catch((error) => {
			console.error('标记其他消息已读失败:', error)
		})
}

const load = () => {
	page.value++
	queryMessageList()
}

const loadOther = () => {
	pageOther.value++
	queryOtherList()
}

const readAllFun = async () => {
	msgLoading.value = true
	try {
		if (activeNameMsg.value == '公告') {
			const res = await branchYueAll()
			if (res.code == 200) {
				ElMessage({
					type: 'success',
					message: res.msg
				})
				msgList.value = []
				queryMessageList()
				getqueryMsgReadOtherNum()
			}
		} else {
			const res = await read_all()
			if (res.code == 200) {
				ElMessage({
					type: 'success',
					message: res.msg
				})
				otherList.value = []
				queryOtherList()
				getqueryMsgReadOtherNum()
			}
		}
	} catch (error) {
		console.error('标记全部已读失败:', error)
	} finally {
		msgLoading.value = false
	}
}

// 生命周期钩子
onMounted(() => {
	if (localStorage.getItem(config.TOKEN)) {
		current_path.value = route.path

		if (!localStorage.getItem('menus')) {
			queryMenus().then(async () => {
				await hierarchyJudgment()
				menus[0].urls = ['/']
				topNaves.value.push(menus[0])
				// 应用导航也加入顶部导航
				if (menus[1] && menus[1].meta.title === '应用导航') {
					menus[1].urls = ['/navigation']
					topNaves.value.push(menus[1])
				}
				apiMenus.value.forEach((item) => {
					menus.forEach((el) => {
						if (el.hideTop) {
							return
						}
						if (item.name == el.meta.title) {
							topNaves.value.push(el)
						}
					})
				})

				selected()
			})
		} else {
			apiMenus.value = JSON.parse(localStorage.getItem('menus'))
			hierarchyJudgment().then(() => {
				menus[0].urls = ['/']
				topNaves.value.push(menus[0])
				// 应用导航也加入顶部导航
				if (menus[1] && menus[1].meta.title === '应用导航') {
					menus[1].urls = ['/navigation']
					topNaves.value.push(menus[1])
				}
				apiMenus.value.forEach((item) => {
					menus.forEach((el) => {
						if (el.hideTop) {
							return
						}
						if (item.name == el.meta.title) {
							topNaves.value.push(el)
						}
					})
				})

				selected()
			})
		}
	} else {
		router.replace('/login')
	}

	getBreadcrumb()
	contentSOCK()
	queryMessageList()
	queryOtherList()
	getqueryMsgReadOtherNum()
	onGetUserInfo()
	window.addEventListener('click', allClick)
})

onBeforeUnmount(() => {
	window.removeEventListener('click', allClick)
})
</script>

<style scoped lang="scss">
.el-asideW {
	width: 200px;
}

.el-asideN {
	width: 0px;
}

.main-content {
	flex: 1;
	overflow: hidden;
}
</style>
